module.exports = __webpack_public_path__ + "img/img_reddot.88f2342d.png";